/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiServerExceptionResponse,
  ChatAgentAddRequest,
  ChatChannel,
  ChatChannelEvent,
  ChatChannelFull,
  ChatChannelNameUpdateRequest,
  ChatChannelResolutionUpdateRequest,
  ChatChannelStatusUpdateRequest,
  ChatClientPersonaUpdateRequest,
  ChatMessage,
  ChatUserCreateRequest,
  ChatUserUpdateRequest,
  CreateQuickReplyRequest,
  DeleteWorkspaceResponse,
  Participant,
  PrivateNoteRequest,
  TokenRequest,
  UpdatePrivateNoteRequest,
  UserModifiedResponse,
  Workspace,
  WorkspaceDomainPersonaCreateRequest,
} from '../models/index';
import {
    ApiServerExceptionResponseFromJSON,
    ApiServerExceptionResponseToJSON,
    ChatAgentAddRequestFromJSON,
    ChatAgentAddRequestToJSON,
    ChatChannelFromJSON,
    ChatChannelToJSON,
    ChatChannelEventFromJSON,
    ChatChannelEventToJSON,
    ChatChannelFullFromJSON,
    ChatChannelFullToJSON,
    ChatChannelNameUpdateRequestFromJSON,
    ChatChannelNameUpdateRequestToJSON,
    ChatChannelResolutionUpdateRequestFromJSON,
    ChatChannelResolutionUpdateRequestToJSON,
    ChatChannelStatusUpdateRequestFromJSON,
    ChatChannelStatusUpdateRequestToJSON,
    ChatClientPersonaUpdateRequestFromJSON,
    ChatClientPersonaUpdateRequestToJSON,
    ChatMessageFromJSON,
    ChatMessageToJSON,
    ChatUserCreateRequestFromJSON,
    ChatUserCreateRequestToJSON,
    ChatUserUpdateRequestFromJSON,
    ChatUserUpdateRequestToJSON,
    CreateQuickReplyRequestFromJSON,
    CreateQuickReplyRequestToJSON,
    DeleteWorkspaceResponseFromJSON,
    DeleteWorkspaceResponseToJSON,
    ParticipantFromJSON,
    ParticipantToJSON,
    PrivateNoteRequestFromJSON,
    PrivateNoteRequestToJSON,
    TokenRequestFromJSON,
    TokenRequestToJSON,
    UpdatePrivateNoteRequestFromJSON,
    UpdatePrivateNoteRequestToJSON,
    UserModifiedResponseFromJSON,
    UserModifiedResponseToJSON,
    WorkspaceFromJSON,
    WorkspaceToJSON,
    WorkspaceDomainPersonaCreateRequestFromJSON,
    WorkspaceDomainPersonaCreateRequestToJSON,
} from '../models/index';

export interface ChatApiAddMemberAsChatAgentRequest {
    workspaceId: string;
    memberId: string;
    chatAgentAddRequest: ChatAgentAddRequest;
}

export interface ChatApiAddParticipantRequest {
    workspaceId: string;
    channelId: string;
    personaId: string;
}

export interface ChatApiCreatePersonaRequest {
    workspaceId: string;
    memberId: string;
    chatUserCreateRequest: ChatUserCreateRequest;
}

export interface ChatApiCreatePrivateNoteRequest {
    workspaceId: string;
    channelId: string;
    privateNoteRequest: PrivateNoteRequest;
}

export interface ChatApiCreateQuickReplyOperationRequest {
    workspaceId: string;
    domainId: string;
    createQuickReplyRequest: CreateQuickReplyRequest;
}

export interface ChatApiCreateWorkspaceDomainPersonaRequest {
    workspaceId: string;
    domainId: string;
    workspaceDomainPersonaCreateRequest: WorkspaceDomainPersonaCreateRequest;
}

export interface ChatApiDeleteRequest {
    workspaceId: string;
    channelId: string;
}

export interface ChatApiDeleteQuickReplyRequest {
    workspaceId: string;
    domainId: string;
    quickReplyId: string;
}

export interface ChatApiDeleteWorkspaceRequest {
    workspaceId: string;
}

export interface ChatApiEventsRequest {
    workspaceId: string;
    channelId: string;
}

export interface ChatApiExportChatChannelAsHtmlRequest {
    workspaceId: string;
    channelId: string;
}

export interface ChatApiExportChatChannelAsPdfRequest {
    workspaceId: string;
    channelId: string;
}

export interface ChatApiGetRequest {
    workspaceId: string;
    channelId: string;
}

export interface ChatApiGetAllRequest {
    workspaceId: string;
}

export interface ChatApiGetAllBotsRequest {
    workspaceId: string;
    domainId: string;
}

export interface ChatApiGetAllPersonasRequest {
    workspaceId: string;
}

export interface ChatApiGetFullRequest {
    workspaceId: string;
    channelId: string;
}

export interface ChatApiGetPersonaRequest {
    workspaceId: string;
    memberId: string;
}

export interface ChatApiGetPrivateNotesRequest {
    workspaceId: string;
    channelId: string;
}

export interface ChatApiGetQuickRepliesRequest {
    workspaceId: string;
    domainId: string;
}

export interface ChatApiGetTokenRequest {
    workspaceId: string;
}

export interface ChatApiHistoryRequest {
    workspaceId: string;
    channelId: string;
}

export interface ChatApiParticipantsRequest {
    workspaceId: string;
    channelId: string;
}

export interface ChatApiRemoveParticipantRequest {
    workspaceId: string;
    channelId: string;
    personaId: string;
}

export interface ChatApiUpdateChatClientPersonaRequest {
    workspaceId: string;
    channelId: string;
    personaId: string;
    chatClientPersonaUpdateRequest: ChatClientPersonaUpdateRequest;
}

export interface ChatApiUpdateNameRequest {
    workspaceId: string;
    channelId: string;
    chatChannelNameUpdateRequest: ChatChannelNameUpdateRequest;
}

export interface ChatApiUpdateParticipantLastReadMessageRequest {
    workspaceId: string;
    channelId: string;
    personaId: string;
    messageId: string;
}

export interface ChatApiUpdatePersonaRequest {
    workspaceId: string;
    memberId: string;
    chatUserUpdateRequest: ChatUserUpdateRequest;
}

export interface ChatApiUpdatePrivateNoteOperationRequest {
    workspaceId: string;
    channelId: string;
    noteId: string;
    updatePrivateNoteRequest: UpdatePrivateNoteRequest;
}

export interface ChatApiUpdateQuickReplyRequest {
    workspaceId: string;
    domainId: string;
    quickReplyId: string;
    createQuickReplyRequest: CreateQuickReplyRequest;
}

export interface ChatApiUpdateResolutionRequest {
    workspaceId: string;
    channelId: string;
    chatChannelResolutionUpdateRequest: ChatChannelResolutionUpdateRequest;
}

export interface ChatApiUpdateStatusRequest {
    workspaceId: string;
    channelId: string;
    chatChannelStatusUpdateRequest: ChatChannelStatusUpdateRequest;
}

/**
 * 
 */
export class ChatApi extends runtime.BaseAPI {

    /**
     * Add a (new) `User` as a Member to a Workspace. Also creates a Chat Persona
     */
    async addMemberAsChatAgentRaw(requestParameters: ChatApiAddMemberAsChatAgentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Workspace>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling addMemberAsChatAgent().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling addMemberAsChatAgent().'
            );
        }

        if (requestParameters['chatAgentAddRequest'] == null) {
            throw new runtime.RequiredError(
                'chatAgentAddRequest',
                'Required parameter "chatAgentAddRequest" was null or undefined when calling addMemberAsChatAgent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/member/{memberId}/addagent`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChatAgentAddRequestToJSON(requestParameters['chatAgentAddRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceFromJSON(jsonValue));
    }

    /**
     * Add a (new) `User` as a Member to a Workspace. Also creates a Chat Persona
     */
    async addMemberAsChatAgent(requestParameters: ChatApiAddMemberAsChatAgentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Workspace> {
        const response = await this.addMemberAsChatAgentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a Chat Agent as a participant to this Channel.
     */
    async addParticipantRaw(requestParameters: ChatApiAddParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatChannel>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling addParticipant().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling addParticipant().'
            );
        }

        if (requestParameters['personaId'] == null) {
            throw new runtime.RequiredError(
                'personaId',
                'Required parameter "personaId" was null or undefined when calling addParticipant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}/participant/{personaId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));
        urlPath = urlPath.replace(`{${"personaId"}}`, encodeURIComponent(String(requestParameters['personaId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatChannelFromJSON(jsonValue));
    }

    /**
     * Add a Chat Agent as a participant to this Channel.
     */
    async addParticipant(requestParameters: ChatApiAddParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatChannel> {
        const response = await this.addParticipantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create a Chat User profile for the provided WorkspaceMember.
     */
    async createPersonaRaw(requestParameters: ChatApiCreatePersonaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling createPersona().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling createPersona().'
            );
        }

        if (requestParameters['chatUserCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'chatUserCreateRequest',
                'Required parameter "chatUserCreateRequest" was null or undefined when calling createPersona().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/member/{memberId}/persona`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChatUserCreateRequestToJSON(requestParameters['chatUserCreateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * create a Chat User profile for the provided WorkspaceMember.
     */
    async createPersona(requestParameters: ChatApiCreatePersonaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createPersonaRaw(requestParameters, initOverrides);
    }

    /**
     * Create a new private note for a channel
     */
    async createPrivateNoteRaw(requestParameters: ChatApiCreatePrivateNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling createPrivateNote().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling createPrivateNote().'
            );
        }

        if (requestParameters['privateNoteRequest'] == null) {
            throw new runtime.RequiredError(
                'privateNoteRequest',
                'Required parameter "privateNoteRequest" was null or undefined when calling createPrivateNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}/notes`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrivateNoteRequestToJSON(requestParameters['privateNoteRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a new private note for a channel
     */
    async createPrivateNote(requestParameters: ChatApiCreatePrivateNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createPrivateNoteRaw(requestParameters, initOverrides);
    }

    /**
     * Create a quick reply
     */
    async createQuickReplyRaw(requestParameters: ChatApiCreateQuickReplyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling createQuickReply().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling createQuickReply().'
            );
        }

        if (requestParameters['createQuickReplyRequest'] == null) {
            throw new runtime.RequiredError(
                'createQuickReplyRequest',
                'Required parameter "createQuickReplyRequest" was null or undefined when calling createQuickReply().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/{domainId}/quickreply`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateQuickReplyRequestToJSON(requestParameters['createQuickReplyRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a quick reply
     */
    async createQuickReply(requestParameters: ChatApiCreateQuickReplyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createQuickReplyRaw(requestParameters, initOverrides);
    }

    /**
     * Create a workspace domain persona.
     */
    async createWorkspaceDomainPersonaRaw(requestParameters: ChatApiCreateWorkspaceDomainPersonaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling createWorkspaceDomainPersona().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling createWorkspaceDomainPersona().'
            );
        }

        if (requestParameters['workspaceDomainPersonaCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'workspaceDomainPersonaCreateRequest',
                'Required parameter "workspaceDomainPersonaCreateRequest" was null or undefined when calling createWorkspaceDomainPersona().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/domain/{domainId}/persona`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkspaceDomainPersonaCreateRequestToJSON(requestParameters['workspaceDomainPersonaCreateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a workspace domain persona.
     */
    async createWorkspaceDomainPersona(requestParameters: ChatApiCreateWorkspaceDomainPersonaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createWorkspaceDomainPersonaRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes a Chat Channel of this user
     */
    async deleteRaw(requestParameters: ChatApiDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatChannel>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling delete().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling delete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatChannelFromJSON(jsonValue));
    }

    /**
     * Deletes a Chat Channel of this user
     */
    async delete(requestParameters: ChatApiDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatChannel> {
        const response = await this.deleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a quick reply
     */
    async deleteQuickReplyRaw(requestParameters: ChatApiDeleteQuickReplyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling deleteQuickReply().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling deleteQuickReply().'
            );
        }

        if (requestParameters['quickReplyId'] == null) {
            throw new runtime.RequiredError(
                'quickReplyId',
                'Required parameter "quickReplyId" was null or undefined when calling deleteQuickReply().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/{domainId}/quickreply/{quickReplyId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));
        urlPath = urlPath.replace(`{${"quickReplyId"}}`, encodeURIComponent(String(requestParameters['quickReplyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a quick reply
     */
    async deleteQuickReply(requestParameters: ChatApiDeleteQuickReplyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteQuickReplyRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a Workspace. This is permanent and can only be done if a workspace does not contain any domains.
     */
    async deleteWorkspaceRaw(requestParameters: ChatApiDeleteWorkspaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteWorkspaceResponse>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling deleteWorkspace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteWorkspaceResponseFromJSON(jsonValue));
    }

    /**
     * Delete a Workspace. This is permanent and can only be done if a workspace does not contain any domains.
     */
    async deleteWorkspace(requestParameters: ChatApiDeleteWorkspaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteWorkspaceResponse> {
        const response = await this.deleteWorkspaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * This endpoint allows a user to remove their ROLE_CHAT_USER role, which will disable chat functionality.
     * Remove the chat user role from the current user
     */
    async disableChatUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserModifiedResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/user/enable`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserModifiedResponseFromJSON(jsonValue));
    }

    /**
     * This endpoint allows a user to remove their ROLE_CHAT_USER role, which will disable chat functionality.
     * Remove the chat user role from the current user
     */
    async disableChatUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserModifiedResponse> {
        const response = await this.disableChatUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * This endpoint allows a user to give themselves the ROLE_CHAT_USER role, which is required to use the chat functionality.
     * Add the chat user role to the current user
     */
    async enableChatUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserModifiedResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/user/enable`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserModifiedResponseFromJSON(jsonValue));
    }

    /**
     * This endpoint allows a user to give themselves the ROLE_CHAT_USER role, which is required to use the chat functionality.
     * Add the chat user role to the current user
     */
    async enableChatUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserModifiedResponse> {
        const response = await this.enableChatUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets all Events of this Channel, ordered by createdAt
     */
    async eventsRaw(requestParameters: ChatApiEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ChatChannelEvent>>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling events().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling events().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}/events`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ChatChannelEventFromJSON));
    }

    /**
     * Gets all Events of this Channel, ordered by createdAt
     */
    async events(requestParameters: ChatApiEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChatChannelEvent>> {
        const response = await this.eventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Exports all messages from a chat channel as an HTML document
     * Export chat channel as HTML
     */
    async exportChatChannelAsHtmlRaw(requestParameters: ChatApiExportChatChannelAsHtmlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling exportChatChannelAsHtml().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling exportChatChannelAsHtml().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}/html`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Exports all messages from a chat channel as an HTML document
     * Export chat channel as HTML
     */
    async exportChatChannelAsHtml(requestParameters: ChatApiExportChatChannelAsHtmlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.exportChatChannelAsHtmlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Exports all messages from a chat channel as a downloadable PDF file
     * Export chat channel as PDF
     */
    async exportChatChannelAsPdfRaw(requestParameters: ChatApiExportChatChannelAsPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling exportChatChannelAsPdf().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling exportChatChannelAsPdf().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}/pdf`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Exports all messages from a chat channel as a downloadable PDF file
     * Export chat channel as PDF
     */
    async exportChatChannelAsPdf(requestParameters: ChatApiExportChatChannelAsPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportChatChannelAsPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a chat channel for the user
     */
    async getRaw(requestParameters: ChatApiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatChannel>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling get().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling get().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatChannelFromJSON(jsonValue));
    }

    /**
     * Get a chat channel for the user
     */
    async get(requestParameters: ChatApiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatChannel> {
        const response = await this.getRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all chat channels for the user
     */
    async getAllRaw(requestParameters: ChatApiGetAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ChatChannel>>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling getAll().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channels`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ChatChannelFromJSON));
    }

    /**
     * Get all chat channels for the user
     */
    async getAll(requestParameters: ChatApiGetAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChatChannel>> {
        const response = await this.getAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all available bots for this Workspace domain.
     */
    async getAllBotsRaw(requestParameters: ChatApiGetAllBotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling getAllBots().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling getAllBots().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/domain/{domainId}/bots`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get all available bots for this Workspace domain.
     */
    async getAllBots(requestParameters: ChatApiGetAllBotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAllBotsRaw(requestParameters, initOverrides);
    }

    /**
     * Get all ChatAgentPersona profiles for this Workspace.
     */
    async getAllPersonasRaw(requestParameters: ChatApiGetAllPersonasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling getAllPersonas().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/members/persona`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get all ChatAgentPersona profiles for this Workspace.
     */
    async getAllPersonas(requestParameters: ChatApiGetAllPersonasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAllPersonasRaw(requestParameters, initOverrides);
    }

    /**
     * Get a chat channel w/ all metadata for the user
     */
    async getFullRaw(requestParameters: ChatApiGetFullRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatChannelFull>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling getFull().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling getFull().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}/full`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatChannelFullFromJSON(jsonValue));
    }

    /**
     * Get a chat channel w/ all metadata for the user
     */
    async getFull(requestParameters: ChatApiGetFullRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatChannelFull> {
        const response = await this.getFullRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the Persona profile for this WorkspaceMember.
     */
    async getPersonaRaw(requestParameters: ChatApiGetPersonaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling getPersona().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling getPersona().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/member/{memberId}/persona`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get the Persona profile for this WorkspaceMember.
     */
    async getPersona(requestParameters: ChatApiGetPersonaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPersonaRaw(requestParameters, initOverrides);
    }

    /**
     * Get all private notes for a channel
     */
    async getPrivateNotesRaw(requestParameters: ChatApiGetPrivateNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling getPrivateNotes().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling getPrivateNotes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}/notes`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get all private notes for a channel
     */
    async getPrivateNotes(requestParameters: ChatApiGetPrivateNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPrivateNotesRaw(requestParameters, initOverrides);
    }

    /**
     * Get quick replies for a workspace domain
     */
    async getQuickRepliesRaw(requestParameters: ChatApiGetQuickRepliesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling getQuickReplies().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling getQuickReplies().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/{domainId}/quickreplies`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get quick replies for a workspace domain
     */
    async getQuickReplies(requestParameters: ChatApiGetQuickRepliesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getQuickRepliesRaw(requestParameters, initOverrides);
    }

    /**
     * Get an Ably (refresh) token. This token also includes the Users\' metadata (notifications) channel.
     */
    async getTokenRaw(requestParameters: ChatApiGetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TokenRequest>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling getToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/token`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenRequestFromJSON(jsonValue));
    }

    /**
     * Get an Ably (refresh) token. This token also includes the Users\' metadata (notifications) channel.
     */
    async getToken(requestParameters: ChatApiGetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TokenRequest> {
        const response = await this.getTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets all Messages of this Channel
     */
    async historyRaw(requestParameters: ChatApiHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ChatMessage>>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling history().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling history().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}/history`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ChatMessageFromJSON));
    }

    /**
     * Gets all Messages of this Channel
     */
    async history(requestParameters: ChatApiHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChatMessage>> {
        const response = await this.historyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets all Participants of this Channel
     */
    async participantsRaw(requestParameters: ChatApiParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Participant>>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling participants().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling participants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}/participants`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ParticipantFromJSON));
    }

    /**
     * Gets all Participants of this Channel
     */
    async participants(requestParameters: ChatApiParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Participant>> {
        const response = await this.participantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a Chat Agent as a participant to this Channel.
     */
    async removeParticipantRaw(requestParameters: ChatApiRemoveParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatChannel>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling removeParticipant().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling removeParticipant().'
            );
        }

        if (requestParameters['personaId'] == null) {
            throw new runtime.RequiredError(
                'personaId',
                'Required parameter "personaId" was null or undefined when calling removeParticipant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}/participant/{personaId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));
        urlPath = urlPath.replace(`{${"personaId"}}`, encodeURIComponent(String(requestParameters['personaId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatChannelFromJSON(jsonValue));
    }

    /**
     * Remove a Chat Agent as a participant to this Channel.
     */
    async removeParticipant(requestParameters: ChatApiRemoveParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatChannel> {
        const response = await this.removeParticipantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * updates a ChatClientPersona profile.
     */
    async updateChatClientPersonaRaw(requestParameters: ChatApiUpdateChatClientPersonaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling updateChatClientPersona().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling updateChatClientPersona().'
            );
        }

        if (requestParameters['personaId'] == null) {
            throw new runtime.RequiredError(
                'personaId',
                'Required parameter "personaId" was null or undefined when calling updateChatClientPersona().'
            );
        }

        if (requestParameters['chatClientPersonaUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'chatClientPersonaUpdateRequest',
                'Required parameter "chatClientPersonaUpdateRequest" was null or undefined when calling updateChatClientPersona().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}/persona/{personaId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));
        urlPath = urlPath.replace(`{${"personaId"}}`, encodeURIComponent(String(requestParameters['personaId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChatClientPersonaUpdateRequestToJSON(requestParameters['chatClientPersonaUpdateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * updates a ChatClientPersona profile.
     */
    async updateChatClientPersona(requestParameters: ChatApiUpdateChatClientPersonaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateChatClientPersonaRaw(requestParameters, initOverrides);
    }

    /**
     * Updates the name of this Channel
     */
    async updateNameRaw(requestParameters: ChatApiUpdateNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatChannel>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling updateName().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling updateName().'
            );
        }

        if (requestParameters['chatChannelNameUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'chatChannelNameUpdateRequest',
                'Required parameter "chatChannelNameUpdateRequest" was null or undefined when calling updateName().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}/name`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChatChannelNameUpdateRequestToJSON(requestParameters['chatChannelNameUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatChannelFromJSON(jsonValue));
    }

    /**
     * Updates the name of this Channel
     */
    async updateName(requestParameters: ChatApiUpdateNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatChannel> {
        const response = await this.updateNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a Participant\'s last read message in this Channel.
     */
    async updateParticipantLastReadMessageRaw(requestParameters: ChatApiUpdateParticipantLastReadMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatChannel>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling updateParticipantLastReadMessage().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling updateParticipantLastReadMessage().'
            );
        }

        if (requestParameters['personaId'] == null) {
            throw new runtime.RequiredError(
                'personaId',
                'Required parameter "personaId" was null or undefined when calling updateParticipantLastReadMessage().'
            );
        }

        if (requestParameters['messageId'] == null) {
            throw new runtime.RequiredError(
                'messageId',
                'Required parameter "messageId" was null or undefined when calling updateParticipantLastReadMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}/participant/{personaId}/lastReadMessage/{messageId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));
        urlPath = urlPath.replace(`{${"personaId"}}`, encodeURIComponent(String(requestParameters['personaId'])));
        urlPath = urlPath.replace(`{${"messageId"}}`, encodeURIComponent(String(requestParameters['messageId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatChannelFromJSON(jsonValue));
    }

    /**
     * Update a Participant\'s last read message in this Channel.
     */
    async updateParticipantLastReadMessage(requestParameters: ChatApiUpdateParticipantLastReadMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatChannel> {
        const response = await this.updateParticipantLastReadMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * updates a ChatAgentPersona profile for the provided WorkspaceMember.
     */
    async updatePersonaRaw(requestParameters: ChatApiUpdatePersonaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling updatePersona().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling updatePersona().'
            );
        }

        if (requestParameters['chatUserUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'chatUserUpdateRequest',
                'Required parameter "chatUserUpdateRequest" was null or undefined when calling updatePersona().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/member/{memberId}/persona`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChatUserUpdateRequestToJSON(requestParameters['chatUserUpdateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * updates a ChatAgentPersona profile for the provided WorkspaceMember.
     */
    async updatePersona(requestParameters: ChatApiUpdatePersonaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePersonaRaw(requestParameters, initOverrides);
    }

    /**
     * Update the status of a private note
     */
    async updatePrivateNoteRaw(requestParameters: ChatApiUpdatePrivateNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling updatePrivateNote().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling updatePrivateNote().'
            );
        }

        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError(
                'noteId',
                'Required parameter "noteId" was null or undefined when calling updatePrivateNote().'
            );
        }

        if (requestParameters['updatePrivateNoteRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePrivateNoteRequest',
                'Required parameter "updatePrivateNoteRequest" was null or undefined when calling updatePrivateNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}/note/{noteId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));
        urlPath = urlPath.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePrivateNoteRequestToJSON(requestParameters['updatePrivateNoteRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update the status of a private note
     */
    async updatePrivateNote(requestParameters: ChatApiUpdatePrivateNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePrivateNoteRaw(requestParameters, initOverrides);
    }

    /**
     * Create a quick reply
     */
    async updateQuickReplyRaw(requestParameters: ChatApiUpdateQuickReplyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling updateQuickReply().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling updateQuickReply().'
            );
        }

        if (requestParameters['quickReplyId'] == null) {
            throw new runtime.RequiredError(
                'quickReplyId',
                'Required parameter "quickReplyId" was null or undefined when calling updateQuickReply().'
            );
        }

        if (requestParameters['createQuickReplyRequest'] == null) {
            throw new runtime.RequiredError(
                'createQuickReplyRequest',
                'Required parameter "createQuickReplyRequest" was null or undefined when calling updateQuickReply().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/{domainId}/quickreply/{quickReplyId}`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));
        urlPath = urlPath.replace(`{${"quickReplyId"}}`, encodeURIComponent(String(requestParameters['quickReplyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CreateQuickReplyRequestToJSON(requestParameters['createQuickReplyRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a quick reply
     */
    async updateQuickReply(requestParameters: ChatApiUpdateQuickReplyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateQuickReplyRaw(requestParameters, initOverrides);
    }

    /**
     * Updates the resolution of this Channel
     */
    async updateResolutionRaw(requestParameters: ChatApiUpdateResolutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatChannel>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling updateResolution().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling updateResolution().'
            );
        }

        if (requestParameters['chatChannelResolutionUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'chatChannelResolutionUpdateRequest',
                'Required parameter "chatChannelResolutionUpdateRequest" was null or undefined when calling updateResolution().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}/resolution`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChatChannelResolutionUpdateRequestToJSON(requestParameters['chatChannelResolutionUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatChannelFromJSON(jsonValue));
    }

    /**
     * Updates the resolution of this Channel
     */
    async updateResolution(requestParameters: ChatApiUpdateResolutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatChannel> {
        const response = await this.updateResolutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the status of this Channel
     */
    async updateStatusRaw(requestParameters: ChatApiUpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatChannel>> {
        if (requestParameters['workspaceId'] == null) {
            throw new runtime.RequiredError(
                'workspaceId',
                'Required parameter "workspaceId" was null or undefined when calling updateStatus().'
            );
        }

        if (requestParameters['channelId'] == null) {
            throw new runtime.RequiredError(
                'channelId',
                'Required parameter "channelId" was null or undefined when calling updateStatus().'
            );
        }

        if (requestParameters['chatChannelStatusUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'chatChannelStatusUpdateRequest',
                'Required parameter "chatChannelStatusUpdateRequest" was null or undefined when calling updateStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/chat/workspace/{workspaceId}/channel/{channelId}/status`;
        urlPath = urlPath.replace(`{${"workspaceId"}}`, encodeURIComponent(String(requestParameters['workspaceId'])));
        urlPath = urlPath.replace(`{${"channelId"}}`, encodeURIComponent(String(requestParameters['channelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChatChannelStatusUpdateRequestToJSON(requestParameters['chatChannelStatusUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatChannelFromJSON(jsonValue));
    }

    /**
     * Updates the status of this Channel
     */
    async updateStatus(requestParameters: ChatApiUpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatChannel> {
        const response = await this.updateStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
